import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/microsoft/backups')
}

export {
  getBackupsByDay,
}
